export const styles = {
  drawerContainer: {
    paddingTop: 7,
    width: 280,
    margin: 1,
  },
}
